import React, { useState } from 'react'
import styled from 'styled-components'
import { Row, Col, Button, Form } from 'react-bootstrap'
import { useHistory } from 'react-router-dom'
import banner from '../../images/event/sponsors.png'
import { COLORS, SIZES } from '../../styles/theme'
import Axios from 'axios'
import config from '../../config'
import { toast } from 'react-toastify'
import routes from '../../routes'
import { first } from 'lodash'

const Page = styled.div`
  min-height: 100vh;
  background-image: url(${config.assets.registration.landscape});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: top;
  padding: 0;
  padding-bottom: 2em;
  padding-top: 2em;
  color: #000000;
  text-align: center;
  // text-transform: uppercase;

  #mobile-show {
    display: none;

    ${SIZES.mobile} {
      display: block;
      margin: 0 auto;
      position: absolute;
      z-index: 1;
    }
  }
  .brand {
    width: 80%;
    height: 100%;
    padding-bottom: 3em;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .disclaimers {
    color: #a7d22b;
  }

  .privacy {
    text-align: center;
    width: 90%;
  }

  .row {
    select.form-input {
      text-align-last: center;
    }

    h6.subtitle {
      margin-top: 25px;
      color: #C10244;
      font-weight: 800;
    }
    .error-message {
      font-weight: 500;
      margin-top: 12rem;
    }

    .agree-box {
      width: 40px;
      height: 20px;
      margin-top: 10px;
    }

    .register-form {
      padding: 2.5em 0;

      .form-group {
        width: 100%;
        margin: 3px auto;
        background: #FFFFFF;
        border: none;
        font-weight: 600;
        text-align: center;
        padding-right: 16px;
        label {
          color: #000000;
          padding: 0 8px;
          margin: 0 auto;
          padding-right: 0;
          font-size: 13px;
        }
        .required:before {
          content:"* ";
          color: red;
        }
        input[type='tel'],
        .form-input {
          display: block;
          color: #484848;
          width: 100%;
          font-weight: 500;
          background: transparent;
          border: none;
          padding: 4px 24px;
          outline: none;
          text-align: center;
        }
      }
      #password {
        width: 12px;
        margin: 2px 4px;
      }
    }
  }
  ${SIZES.mobile} {
    background-image: url(${config.assets.registration.portrait});
    padding: 1em 0;
    padding-bottom: 2.5em;
    padding-top: 1em;
    font-size: 0.9em;
    .mobile-show {
      display: block;
    }
    .mobile-hide {
      display: none;
    }
    .col-md-6 {
      flex: none;
      max-width: 100%
    }
    .subtitle, .error-message {
      padding: 0 20px;
      font-size: 12px;
      font-weight: 600;
    }
    .error-message {
      margin-top: 20rem !important;
    }
  }


  button.submit-btn {
    background: #a7d22b75;
    box-shadow: 0 5px 4px -4px #000000;
    width: 50%;
    color: #000000;
    font-weight: 500;
    border: none;
    border-radius: 56px;
    display: flex;
    justify-content: space-between;
    padding: 5px 24px;
    margin: 16px auto;
    margin-bottom: 0;
    font-size: 1em;
    outline: none;

    ${SIZES.mobile} {
      width: 60%;
      padding: 10px 24px;
    }

    &:disabled {
      cursor: not-allowed;
      background: grey;
      border: solid 1px ${COLORS.primary};
    }

    div {
      line-height: 32px;
    }
  }
`

export default function RegisterFormPage() {
  const history = useHistory()

  const [loading, setLoading] = useState(false)
  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')
  const [organisation, setOrganisation] = useState('')
  const [country, setCountry] = useState('')
  const [email, setEmail] = useState('')
  const [agree, setAgree] = useState(false)
  const [phone, setPhone] = useState('')

  const handleEmailInput = (e) => {
    setEmail(e.target.value.toLowerCase())
  }
 
  const handleCheckBox = (e) => {
    setAgree(e.target.checked)
  }


  const handleSubmit = (e) => {
    e.preventDefault()
    setLoading(true)
    if (!agree) {
      toast('Please indicate that you have read and agree to the Terms and Conditions and Privacy Notice before login')
      return
    }
    const options = {
      first_name: firstName.trim(),
      last_name: lastName.trim(),
      country: country.trim(),
      organisation: organisation.trim(),
      email,
      phone: phone.trim(),
    }
    Axios.post(`${config.apiUrl}/api/register`, options)
      .then(() => {
        setLoading(false)
        history.push(routes.postRegister)
      })
      .catch((err) => {
        setLoading(false)
        toast(err.response.data.message)
      })
  }

  const hasEmptyField = !(
    firstName.length &&
    lastName.length &&
    organisation.length &&
    country.length &&
    email.length &&
    phone.length >= 9 &&
    agree
  )

  return (
    <Page>
      <div id="mobile-show">
        <img src={banner} width="100%" alt="sponsor banner" />
      </div>
      <Row id="main" noGutters className="px-4 pl-md-0 pt-2 pb-3">

        <Col md={6} className="mobile-hide">
          <div className="brand">
            {/* <img width="100%" src={bannerL} alt="event-banner" className="d-block ml-0 mr-auto" /> */}
            {/* <img width="60%" src={logo} alt="event-logo" className="d-block mr-0 ml-auto" /> */}
          </div>
        </Col>

        <Col md={6} className="px-md-4= error-message">
          <h6 className="subtitle">Kindly fill in required information below</h6>
          {/* {hasEmptyField && (
            <p className="error-message m-0">
              * Please fill in the required field to proceed.
            </p>
          )} */}
          <Row className="register-form py-3" noGutters>
            <Col md={12} className="pr-md-4">
              <Form.Group>
                <label className="required">First Name</label>
                <input
                  className="form-input"
                  required
                  type="text"
                  value={firstName}
                  onChange={(e) => setFirstName(e.target.value)}
                />
              </Form.Group>
            </Col>

            <Col md={12} className="pr-md-4">
              <Form.Group>
                <label className="required">Last Name</label>
                <input
                  className="form-input"
                  required
                  type="text"
                  value={lastName}
                  onChange={(e) => setLastName(e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col md={12} className="pr-md-4">
              <Form.Group>
                <label className="required">Email</label>
                <input
                  className="form-input"
                  required
                  type="email"
                  value={email}
                  onChange={handleEmailInput}
                />
              </Form.Group>
            </Col>

            <Col md={12} className="pr-md-4">
              <Form.Group>
                <label className="required">Organisation</label>
                <input
                  className="form-input"
                  required
                  type="text"
                  value={organisation}
                  onChange={(e) => setOrganisation(e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col md={12} className="pr-md-4">
              <Form.Group>
                <label className="required">Country</label>
                <input
                  className="form-input"
                  required
                  type="text"
                  value={country}
                  onChange={(e) => setCountry(e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col md={12} className="pr-md-4">
              <Form.Group>
                <label className="required">Mobile</label>
                <input
                  className="form-input"
                  required
                  type="tel"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                />
              </Form.Group>
            </Col>
              <div className="privacy mb-2 pr-md-4">
                <div className="form-check">
                  <input type="checkbox" className="agree-box" onChange={handleCheckBox} />
                  <label className="form-check-label text-left">
                  <span>*</span> I have read <a href="https://drive.google.com/file/d/1Xvl0527zAK3GjJG-thP25zYjl-S32W2X/view?usp=sharing" target="_blank" className="disclaimers">disclaimers</a> and agree to proceed.
                  </label>
                </div>
                
              </div>

            <div className="w-100 pr-md-4">
              <Button
                type="submit"
                className="submit-btn"
                variant="default"
                disabled={hasEmptyField || loading}
                onClick={handleSubmit}
              >
                <div>{loading ? 'Loading...' : 'SUBMIT'}</div>
                <div className="arrow">⇀</div>
              </Button>
            </div>
          </Row>
        </Col>
      </Row>
      <div className="mobile-show">
        {/* <img width="40%" src={logo} alt="event-logo" className="d-block mx-auto" /> */}
      </div>
    </Page>
  )
}
